import {
	Component,
	ElementRef,
	HostListener,
	inject,
	input,
	OnInit,
	signal,
} from '@angular/core';

import { ImageComponent as UIImage } from '@valk-nx/components/ui-image/src/lib/image.component';
import { ImageInterface } from '@valk-nx/components/ui-image/src/lib/image.interface';
import { debounceFn } from '@valk-nx/helpers/lib/debounce/debounce.helper';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import {
	BynderImage,
	ImageAspectRatio,
} from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-image',
	templateUrl: './image.html',
	imports: [UIImage, StoryblokDirective],
	styles: [
		`
			:host {
				display: block;
			}
		`,
	],
})
export class ImageComponent extends StoryblokRootDirective implements OnInit {
	private readonly el = inject(ElementRef);

	bynder = input<BynderImage[] | undefined>();
	imageAlt = input<string>('');
	imageWidth = input<number>(1920);
	aspectRatio = input<ImageAspectRatio>('16:9');
	className = input<string>('');

	vpImage = signal<ImageInterface>({ src: '', width: 0, height: 0 });

	private readonly debouncedSetImage = debounceFn(() => this.setImage(), 300);

	ngOnInit(): void {
		this.setImage();
	}

	calculateImageHeight(width: number) {
		const aspectRatio = this.aspectRatio().split(':');
		return Math.round(
			(width / parseInt(aspectRatio[0], 10)) *
				parseInt(aspectRatio[1], 10),
		);
	}

	@HostListener('window:resize')
	onResize(): void {
		this.debouncedSetImage();
	}

	setImage(): void {
		const width = this.el.nativeElement.offsetWidth || this.imageWidth();
		const src = this.bynder()?.[0]?.files?.transformBaseUrl?.url ?? '';
		this.vpImage.set({
			src: src,
			altText: this.imageAlt(),
			width,
			height: this.calculateImageHeight(width),
		});
	}
}
